var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonuploadreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19 18.996V19h14.858v-.003C21.8 18.895 24 16.61 24 13.806c0-2.867-2.302-5.192-5.143-5.192h-.265C17.737 5.895 16 3 11.62 3 7 3 4.771 6.688 4.5 10.154h-.119c-2.42 0-4.381 1.98-4.381 4.423 0 2.378 1.86 4.318 4.19 4.419zM10.01 19h4v-2.5a.5.5 0 01.5-.5h1.317a1 1 0 00.759-1.65l-3.826-4.464a1 1 0 00-1.518 0l-3.826 4.463A1 1 0 008.175 16h1.334a.5.5 0 01.5.5V19z",
    fill: "#A3A9AE"
  })));
}
export default SvgButtonuploadreact;